import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BSSINESS_CARDS, HOMEPAGE_CARDS } from "../../../helpers/constants";
import HomeHeader from "./HomeHeader";
import HomeContainer from "./HomeContainer";
import HomeFooter from "./HomeFooter";
import { i18n } from "../private/languageSelector";
import PricingPage from "./pages/PricingPage";
import BenefitsDetailPage from "./pages/BenefitsDetailPage";
import { Helmet } from "react-helmet";

const HomeWrapper = () => {
  //eslint-disable-next-line
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const selectedLanguage = localStorage.getItem("language");

  const location = useLocation();
  const showPricing = location.state?.showPricing || false;
  const showTabletBasedBenefits = location?.state?.tablet_based_pos || false;
  const showProductManagementBenefits = location?.state?.product_management || false;
  const showBranchManagementBenefits = location?.state?.branch_management || false;
  const showReportAndAnalyticsBenefits = location?.state?.reports_and_analytics || false;

  return (
    <div id="home_wrapper_main">
      <Helmet>
        <html lang={selectedLanguage === "arabic" ? "ar" : "en"} />

        <title>{selectedLanguage === "arabic" ? "فاتورتي | نظام الفوترة ونقاط البيع" : "Fatoraty | POS & E-Invoicing Solution"}</title>

        <meta
          name="description"
          content={
            selectedLanguage === "arabic"
              ? "فاتورتي نظام نقاط بيع وفوترة إلكترونية لإدارة الأعمال"
              : "Fatoraty provides POS and e-invoicing solutions for businesses."
          }
        />

        <meta
          property="og:title"
          content={selectedLanguage === "arabic" ? "فاتورتي | نظام الفوترة ونقاط البيع" : "Fatoraty | POS & E-Invoicing Solution"}
        />

        <meta
          property="og:description"
          content={
            selectedLanguage === "arabic"
              ? "فاتورتي نظام نقاط بيع وفوترة إلكترونية لإدارة الأعمال"
              : "Fatoraty provides POS and e-invoicing solutions for businesses."
          }
        />

        {/* <link rel="canonical" href="https://staging.fatoraty.com/homePage" /> */}
        <link rel="canonical" href="http://localhost:3000/homePage" />
      </Helmet>
      <div className="homePage-wrapper pt-5" style={{ overflowX: "hidden" }} id="homepage_wrapper">
        <HomeHeader />

        {showPricing ? (
          <PricingPage />
        ) : showTabletBasedBenefits || showProductManagementBenefits || showBranchManagementBenefits || showReportAndAnalyticsBenefits ? (
          <>
            <BenefitsDetailPage state={location?.state} />
          </>
        ) : (
          <>
            <HomeContainer />

            <div className="cards-details ">
              <div className="container pt-5">
                <div
                  style={{ maxWidth: "1300px", justifyContent: "center", flexDirection: selectedLanguage === "arabic" ? "row-reverse" : "row" }}
                  className="d-flex flex-wrap"
                >
                  {HOMEPAGE_CARDS.map((card, index) => (
                    <div key={index} className="home-card" style={{ width: "100%", marginBottom: "38px", borderRadius: "10px" }}>
                      <div>
                        <div style={{ alignContent: "center", alignItems: "center" }} className="p-5">
                          <div style={{ textAlign: "center", alignContent: "center", alignItems: "center" }}>
                            <img className="homeCard-img" src={card?.item?.img} alt="card_img" />
                          </div>
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "18px",
                              color: "#4F4F4F",
                              lineHeight: "24px",
                              textAlign: "center",
                              alignContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {selectedLanguage === "arabic" ? card?.item?.arabicTag : card?.item?.tag}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="started-header">
              <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <p className="tool-text" style={{ fontWeight: "600", fontSize: "35px", color: "#FFFFFF", textAlign: "center" }}>
                  {i18n("HomePage.WhatIsYourBusiness")}
                </p>
              </div>
            </div>
            <div className="bussiness-card-wrapper" style={{ maxWidth: "1100px", margin: "0 auto", display: "flex", justifyContent: "center" }}>
              <div className="row" style={{ flexDirection: selectedLanguage === "arabic" ? "row-reverse" : "row" }}>
                {BSSINESS_CARDS.map((card, index) => (
                  <div key={index} className="col-6 col-md-4 p-0">
                    <div className="bussiness-card">
                      <div className="p-5">
                        <p
                          className="m-0 p-0"
                          style={{
                            fontWeight: "400",

                            color: "#4F4F4F",
                            textAlign: "center",
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {/* {screenSize < 700 && card?.item?.tag === "Clothes & Retail" ? "Retail" : card?.item?.tag} */}
                          {selectedLanguage === "arabic" ? card?.item?.arabicTag : card?.item?.tag}
                        </p>
                        <div className="text-center">
                          <img width={"100%"} src={card?.item?.img} alt="card_img" />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        <HomeFooter />
      </div>
    </div>
  );
};

export default HomeWrapper;
